import {DerivedUnderwritingProfileStatus} from '../underwriting';
import {Dropdown} from './dropdown';

const UNDERWRITING_PROFILE_STATUS_OPTIONS_FR: Dropdown<DerivedUnderwritingProfileStatus>[] = [
  {name: 'Approuvé', value: DerivedUnderwritingProfileStatus.APPROVED},
  {name: 'Refusé', value: DerivedUnderwritingProfileStatus.REFUSED},
  {name: 'En attente du tarificateur', value: DerivedUnderwritingProfileStatus.PENDING_UNDERWRITER_ACTION},
  {name: 'En attente du client', value: DerivedUnderwritingProfileStatus.PENDING_CLIENT_ACTION},
  {
    name: `En attente d'un partenaire externe`,
    value: DerivedUnderwritingProfileStatus.PENDING_EXTERNAL_ACTION,
  },
];

const UNDERWRITING_PROFILE_STATUS_OPTIONS_EN: Dropdown<DerivedUnderwritingProfileStatus>[] = [
  {name: 'Approved', value: DerivedUnderwritingProfileStatus.APPROVED},
  {name: 'Refused', value: DerivedUnderwritingProfileStatus.REFUSED},
  {name: 'Pending underwriter', value: DerivedUnderwritingProfileStatus.PENDING_UNDERWRITER_ACTION},
  {name: 'Pending client', value: DerivedUnderwritingProfileStatus.PENDING_CLIENT_ACTION},
  {name: 'Pending external partner', value: DerivedUnderwritingProfileStatus.PENDING_EXTERNAL_ACTION},
];

export const UNDERWRITING_PROFILE_STATUS_OPTIONS = {
  en: UNDERWRITING_PROFILE_STATUS_OPTIONS_EN,
  fr: UNDERWRITING_PROFILE_STATUS_OPTIONS_FR,
};
